<template>
    <div>
        {{ formatDate(item[header.value]) }}
    </div>
</template>

<script setup>

import { defineProps } from 'vue'
import { useFilters } from '@/composables/useFilters'

const { formatDate } = useFilters()

const props = defineProps({
    header: { type: Object, required: true },
    item: { type: Object, required: true },
})

</script>